module.exports = __webpack_public_path__ + "img/image111.4c45609d.jpg";